/* eslint-disable @typescript-eslint/no-explicit-any */

import DataRow from "./dataRow";

type RenderDataRowProps = {
  dateFrom: any;
  dateTo: any;
  overviewData: any;
};

export const renderDataRow = ({
  dateFrom,
  dateTo,
  overviewData,
}: RenderDataRowProps) => {
  if (!overviewData) {
    return null;
  }
  const totalCount =
    !overviewData || !overviewData.TOTAL || overviewData.TOTAL.count === null
      ? "-"
      : overviewData.TOTAL.count;
  return (
    <DataRow
      dateFrom={dateFrom}
      dateTo={dateTo}
      overviewData={overviewData}
      totalCount={totalCount}
    />
  );
};
